import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { REVIEWS } from "@/data/content";

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 md:py-32 bg-[#101C3E]/30">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="mb-16 text-center">
          <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] font-medium mb-6">
            Reviews
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight leading-tight text-slate-50">
            Words from our <span className="italic text-[#d4af37]">travellers.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.1}>
              <figure
                data-testid={`review-card-${i}`}
                className="h-full backdrop-blur-xl bg-[#101C3E]/60 border border-[#d4af37]/20 p-8 flex flex-col hover:border-[#d4af37]/50 transition-colors duration-500"
              >
                <Quote size={28} className="text-[#d4af37]/50 mb-6" />
                <blockquote className="text-slate-300 leading-relaxed flex-1">
                  {r.quote}
                </blockquote>
                <figcaption className="mt-8 pt-6 border-t border-[#d4af37]/15 flex items-center justify-between">
                  <div>
                    <p className="font-display text-lg text-slate-50">{r.name}</p>
                    <p className="text-xs tracking-[0.15em] uppercase text-slate-400 mt-1">
                      {r.place}
                    </p>
                  </div>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={13} className="fill-[#d4af37] text-[#d4af37]" />
                    ))}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
